import React, { Component } from "react";
import { ErrorMessage } from "formik";
import "./ParticipantForm.scss";
import { connect } from "react-redux";
import { getLinkedParticipants } from "../action-creators/signedWaiver";
import { difference } from "ramda";

class DropDown extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.textInput = null;
    this.setTextInputRef = element => {
      this.textInput = element;
    };
    this.state = {
      name: this.props.value || "",
      referenceKey: "",
      id: "",
      droppedDown: false
    };
  }

  handleClick = (index, participant, event) => {
    this.setState({
      name: participant.participantName,
      id: participant.participantId,
      referenceKey: participant.referenceKey,
      droppedDown: false
    });
    this.props.form.setFieldTouched(`${this.props.field.name}`, true, true);
    this.props.form.setFieldValue(
      `${this.props.field.name}`,
      participant.participantName
    );
    this.props.onChange(participant.participantId);
  };

  handleDroppedDown = () => {
    this.setState({ droppedDown: !this.state.droppedDown });
  };

  handleInputChange = event => {
    if (this.props.onChange) {
      this.props.onChange(event, this.state.referenceKey);
    }
    this.props.form.setFieldTouched(`${this.props.field.name}`, true, true);
    this.props.form.setFieldValue(
      `${this.props.field.name}`,
      this.textInput.value
    );
    this.setState({ name: this.textInput.value });
  };

  render() {
    const {
      participants,
      name,
      label,
      placeholder,
      validate,
      index
    } = this.props;

    return (
      <React.Fragment>
        <label className="label">{label}</label>
        <div className="field-dropdown field has-addons">
          <div className="control">
            <input
              validate={validate}
              type="text"
              index={index}
              ref={this.setTextInputRef}
              placeholder={placeholder}
              name={name}
              className="input"
              value={this.state.name}
              onChange={this.handleInputChange}
            />
            {this.props.form.touched[this.props.field.name] &&
            this.props.form.errors[this.props.field.name] ? (
              <span className="validation-message">
                {this.props.form.errors[this.props.field.name]}
              </span>
            ) : (
              <ErrorMessage
                name={`linkedParticipants.${index}.participantName`}
                className="validation-message"
                component="span"
              />
            )}
          </div>

          {participants && participants.length > 0 ? (
            <React.Fragment>
              <div
                className="control"
                aria-haspopup="true"
                aria-controls="dropdown-menu"
                onClick={this.handleDroppedDown}
              >
                <a className="button" >
                  <i className="fas fa-caret-down" aria-hidden="true" />
                </a>
              </div>
            </React.Fragment>
          ) : null}
        </div>

        {this.state.droppedDown ? (
          <div className="dropdown-content">
            {difference(
              this.props.participants,
              this.props.pathParticipants.selectedParticipants
            ).map((participant, index) => (
              <a
                className="dropdown-item"
                onClick={e => this.handleClick(index, participant, e)}
                key={index}
              >
                {participant.participantName}
              </a>
            ))}
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    participants: state.pathParticipants.participants,
    updatedParticipants: state.pathParticipants.updatedParticipants,
    waiver: state.currentWaiver,
    signingInfo: state.signingInfo,
    pathParticipants: state.pathParticipants,
    linkedParticipant: state.pathParticipants.selectedParticipantsName,
    role: state.signingInfo.role,
    linkedParticipants: state.pathParticipants.linkedParticipants
  };
};

const mapActionsToProps = dispatch => {
  return {
    getLinkedParticipants: value => dispatch(getLinkedParticipants(value))
  };
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(DropDown);
